import {Component} from "@angular/core";
import {Business} from "../../../model/business";
import {BusinessService} from "../../../services/data/business.service";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {Router} from "@angular/router";
import {AuthentService} from "../../../services/authent.service";
import {BusinessRight} from "../../../model/business-right";
import {UrlService} from "../../../services/url.service";

@Component({
    selector: 'business-list',
    template: require('./business-list.component.html'),
    styles: [
        require('./business-list.component.scss')
    ]
})

export class BusinessListComponent {
    businesses:Business[] = [];
    model: Business = new Business()
    submitted: boolean = false;

    constructor(private currentBusinessService: CurrentBusinessService,
                private businessService: BusinessService,
                private authent: AuthentService,
                private router: Router,
                private urlService: UrlService) {
        if(currentBusinessService.businesses != null) {
            this.businesses = currentBusinessService.businesses.map(business => {
                business.logoPath = urlService.getUploadBusinessLogoUrl(business.id) + '?access_token=' + this.authent.getToken();

                return business;
            });
        }

        currentBusinessService.businessesChange$.subscribe( businesses => {
            this.businesses = businesses;
        })

    }

    chooseBusiness(business: Business) {
        this.currentBusinessService.changeBusiness(business);
        this.businessService.getRight(business.id).subscribe(
            right => this.rightLoaded(right)
        );
    }

    rightLoaded(right: BusinessRight) {
        this.authent.setRight(right);
        this.router.navigateByUrl('home/events');
    }

    businessEnter(event: KeyboardEvent) {
      if(this.model.name!='' && this.model.name.length<=30) {
        this.newBusiness();
      }
    }

    newBusiness() {
        this.submitted = true;

        this.businessService.createBusiness(this.model)
            .subscribe(
                business => {
                    this.model = new Business();
                    this.currentBusinessService.changeBusiness(business);
                    this.authent.setRight(new BusinessRight(true, true, true));
                    this.businesses.push(this.currentBusinessService.currentBusiness);

                    this.businessService.getRight(business.id).subscribe(
                      right => this.creationRightLoaded(right)
                    );
                },
                error => {
                    console.log(error)
                }
            );

    }

    creationRightLoaded(right: BusinessRight) {
      this.authent.setRight(right);
      this.router.navigateByUrl('/profile');
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/business/list/business-list.component.ts